import React, { useEffect, useContext, useState } from 'react';
import { Form, Input, Button, Select, DatePicker, Checkbox, Modal, Avatar, Typography, Drawer, message } from 'antd';
import { UserOutlined, RightOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import ProfilePageV2 from '../../pages/ProfilePageV2';
import AuthContext from '../../context/authContext';
// 位置權限相關導入已移除（現在使用自動定位系統）
import '../../components/style/memberPrfileStyle.css';//memberPrfileStyle.css
import { ORIGINAL_URL } from '../../configuration';

const MobileProfile = () => {

    const [openDrawer, setOpenDrawer] = useState(false);
    // 自動定位系統不需要手動設定 Modal
    

    const showDrawer = () => {
        setOpenDrawer(true);
    };
    const closeDrawer = () => {
        setOpenDrawer(false);
    };

    const authCtx = useContext(AuthContext);

    const TAG = "[MemberProfile] :";

    const [finishLayaltyCardCount, setFinishLayaltyCardCount] = useState(0);

    // 自動定位系統狀態顯示
    const getLocationStatusText = () => {
        if (authCtx.currentLocation) {
            const source = authCtx.currentLocation.source;
            switch (source) {
                case 'gps':
                    return '使用 GPS 定位';
                case 'network':
                    return '使用網路定位';
                case 'fallback':
                    return '使用永靖預設位置';
                default:
                    return '已自動定位';
            }
        }
        return '自動定位中...';
    };

    useEffect(() => {

        // console.log("[MobileProfile] 進入點: "+location.pathname);
        // console.log("[MobileProfile] authCtx.isUpdateInfo: "+authCtx.isUpdateInfo);
        localStorage.setItem(ORIGINAL_URL, location.pathname);

        if(!authCtx.isUpdateInfo || !authCtx.isMobileLogin) {     
            authCtx.updateUserInfo();
        } else {
            // console.log(TAG+"處理集章卡數據，總共有"+authCtx.userInfo?.publicLayaltyCards.length+"張");

            let layaltyCardCount = 0;
    
            for (let index = 0; index < authCtx.userInfo?.publicLayaltyCards.length; index++) {
                if(authCtx.userInfo?.publicLayaltyCards[index].is_done){
                    layaltyCardCount++;
                    
                }
            }
    
            setFinishLayaltyCardCount(layaltyCardCount);
        }


    }, [location.pathname]);

    

    return (
        <>

            { (authCtx.isMobileLogin && authCtx.isUpdateInfo ) &&
                <>
                
                <Drawer title="會員資訊" placement="right" onClose={closeDrawer} open={openDrawer} >
                    <ProfilePageV2 />
                </Drawer>
                <div className=' p-2 mb-2 w-full bg-white flex shadow-md rounded-lg justify-center items-center'>
                    <div className='flex h-24 sm:h-32  p-2 w-full'>
                    
                        <div className='flex-col mr-8 sm:mr-9  flex justify-center items-center'>
                            <Avatar className='ant-avatar' src={authCtx.userInfo?.profile_picture} size={64} alt="user_avatar" />  
                            <div className=' font-medium  pt-1'>{authCtx.userInfo?.nick_name}</div>
                        </div>
                        <div className='h-full flex justify-center items-center flex-1'>
                            <div className=' text-slate-500 flex-1'>
                                <div className=' text-base'>
                                    {finishLayaltyCardCount} / {authCtx.userInfo?.publicLayaltyCards.length}
                                    
                                </div>
                                <div className='pt-2 text-base'>
                                    集點券
                                </div>
                            </div>
                            <div className=' text-slate-500  flex-1'>
                                <div className=' text-base' >{authCtx.userInfo?.voucherCount}</div>
                                <div className='pt-2 text-base'>兌換券 </div>
                            </div>
                            <div className=' text-slate-400 flex-1'>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='flex flex-col bg-white shadow-md rounded-lg'>
                    <div className=' h-10 p-2 flex items-center justify-between w-full' onClick={showDrawer}>
                        <div> 編輯會員資訊 </div>
                        <RightOutlined className=' text-slate-400' />
                    </div>
                </div>

                {/* 位置權限設定區塊 */}
                <div className='flex flex-col bg-white shadow-md rounded-lg mt-2'>
                    <div className=' h-10 p-2 flex items-center justify-between w-full'>
                        <div className='flex items-center'>
                            <FontAwesomeIcon icon={faLocationDot} className='text-primary mr-2' />
                            <span>位置狀態</span>
                        </div>
                        <div className='flex items-center'>
                            <span className='text-sm text-slate-500 mr-1'>
                                {getLocationStatusText()}
                            </span>
                            <RightOutlined className=' text-slate-400' />
                        </div>
                    </div>
                    <div className='px-2 pb-2 text-xs text-slate-400'>
                        系統會自動定位，精度不足時使用永靖鄉預設位置
                    </div>
                </div>

                {/* 自動定位系統不需要權限設定 Modal */}
                </>
            }
            
        </>
    )

}


export default MobileProfile;